import { get, isArray } from "lodash";
import React from "react";
import Functions from "../../src/functions";

function Mapper(data, status, response, error, component) {
    let output = [];
    if (data) {
        if (data.data) {
            data.data.map((itm, idx) => {
                let property = {};

                property["id"] = itm._id;
                property["mike"] = itm.firstName + " " + itm.lastName;
                property["email"] = itm.email;
                property["year"] = itm.dob;

                output.push(property);
            });
        }
    }

    return output;
}

function Properties(args) {
    let editable = args.editable ? true : false;
    return {
        id: {
            alias: "id",
            type: "text",
            label: "ID",
            editable: editable
        },
        mike: {
            alias: "mike",
            type: "text",
            label: "ID",
            editable: editable,
        },
        email: {
            alias: "email",
            type: "text",
            label: "ID",
            editable: editable,
        },
        year: {
            alias: "year",
            type: "button",
            label: "ID",
            caption: "Click in here!",
            editable: editable,
            events: {
                onClick: function () {
                    Functions["custom"].testFunction();
                },
            },
            attributes: {
                className: "btn btn-submit",
            },
        }
    };
}

const Form = {
    auth: "",
    views: {
        list: {
            apis: {
                view: {
                    data: {
                        "data": [
                            {
                                "_id": "62b2465e0670000015000247",
                                "firstName": "Makis",
                                "lastName": "Allos",
                                "email": "hello@cognity.gr",
                                "dob": "1982-03-08T22:00:00Z"
                            }
                        ],
                        "exceptions": [],
                        "pagination": []
                    },
                    replace: {},
                    mapper: Mapper,
                },
            },
            template: "form",
            templateConfiguration: {
                includeProperties: [],
                excludeProperties: [],
                events: {
                    onSubmit: function (e) {},
                },
            },
            properties: Properties({ editable: true }),
            primaryKey: "id",
        },
    },
};

export default Form;